<template>
  <div class="landing-wrapper">
    <v-container class="py-8 py-md-12" fluid>
      <v-row justify="center">
        <v-col cols="12" lg="10">
          <div class="section-panel">
            <div class="section-panel-header">
              <v-icon size="22" color="#ffffff">mdi-drama-masks</v-icon>
              <span>QUIENES SOMOS</span>
            </div>

            <div class="about-body">
              <p
                v-for="(paragraph, index) in paragraphs"
                :key="index"
                class="about-text"
                :class="{ 'about-text-closing': index === paragraphs.length - 1 }"
              >
                {{ paragraph }}
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <teatro-footer />
  </div>
</template>

<script>
// Texto institucional. Va en el componente y no en la base de datos: es una
// página fija, sin administración propia (a diferencia de las preguntas
// frecuentes, que sí se cargan desde el admin).
const ABOUT_PARAGRAPHS = [
  "Solimano Comunicaciones se ha unido con la empresa de desarrollo de " +
    "sistemas computacionales 7 y + D SpA, para ofrecer una plataforma en la " +
    "que puede encontrar una variada oferta Teatral, en los formatos Drama, " +
    "Comedia, Teatro Infantil, Comedia musical, Teatro Capacitación y Stand Up " +
    "Comedy.",
  "Representa una ventana de exhibición para las Compañías de Teatro, donde " +
    "los interesados, por medio de un procedimiento simple y directo, " +
    "contratan las obras que les resulten atractivas.",
  "El portal Somos Teatro llega para simplificar la forma de unir la oferta y " +
    "la demanda de la creación artística nacional y extranjera.",
  "Los invitamos a disfrutar del teatro.",
];

export default {
  name: "TeatroAbout",
  data() {
    return {
      paragraphs: ABOUT_PARAGRAPHS,
    };
  },
};
</script>

<style scoped>
/* Mismo panel que el resto de las secciones de contenido (ver Faq.vue). */
.section-panel {
  max-width: 1080px;
  margin: 0 auto;
  background: rgba(8, 5, 5, 0.66);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 26px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
}

.section-panel-header {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 66px;
  padding: 0 32px;
  background: linear-gradient(90deg, #c8102e 0%, #a50d25 100%);
  color: #fff;
  font-family: var(--font-family-heading);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.4px;
}

.about-body {
  padding: 30px 34px 34px;
}

.about-text {
  margin: 0 0 18px;
  color: var(--color-theater-text);
  font-size: 15px;
  line-height: 1.75;
  text-align: justify;
}

.about-text:last-child {
  margin-bottom: 0;
}

/* "Los invitamos a disfrutar del teatro." cierra la página. */
.about-text-closing {
  font-family: var(--font-family-heading);
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.6px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
}

@media (max-width: 600px) {
  .about-body {
    padding: 24px 20px 28px;
  }

  .about-text {
    font-size: 14px;
    text-align: left;
  }
}
</style>
